import { render } from "./SidebarSenha.vue?vue&type=template&id=5544932e&scoped=true"
import script from "./SidebarSenha.vue?vue&type=script&lang=js"
export * from "./SidebarSenha.vue?vue&type=script&lang=js"

import "./SidebarSenha.vue?vue&type=style&index=0&id=5544932e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5544932e"]])

export default __exports__